$(function(){
  $('.radioBtnOther').on('click',function(){
    $(this).parent().find(".radioBtn").click();
  });
  $('.arrayOther').on('click',function(){
    $(this).parent().find(".checkBoxBtn").prop('checked', true);;
  });
});
